import { render, staticRenderFns } from "./Returns.vue?vue&type=template&id=ad816f40"
import script from "./Returns.vue?vue&type=script&lang=ts&setup=true"
export * from "./Returns.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Returns.vue?vue&type=style&index=0&id=ad816f40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports